import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import {
    FAILURE_ORDER_PRODUCTS_BY_ORDER_ID,
    REQUEST_ORDER_PRODUCTS_BY_ORDER_ID,
    SUCCESS_ORDER_PRODUCTS_BY_ORDER_ID,
} from './actions';

export function orderProductsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORDER_PRODUCTS_BY_ORDER_ID:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORDER_PRODUCTS_BY_ORDER_ID: {
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        }
        case FAILURE_ORDER_PRODUCTS_BY_ORDER_ID:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
